// extracted by mini-css-extract-plugin
module.exports = {"ul":"Navbar_ul__21kdA","li":"Navbar_li__2ja4s","title":"Navbar_title__i9AGF","listItem":"Navbar_listItem__3A8fR"};